import { defineSlotRecipe } from '@chakra-ui/react';

export const faqSlotRecipe = defineSlotRecipe({
    slots: ['root', 'title', 'itemTrigger', 'itemContent'],
    base: {
        root: {
            gap: 2,
            borderRadius: 'md',
            boxShadow: 'tile',
            mb: 6,
        },
        title: {
            fontSize: 'lg',
            fontWeight: 'bold',
            px: 4,
            pt: 4,
            pb: 2,
        },
        itemTrigger: {
            px: 4,
            py: 3,
            cursor: 'pointer',
        },
        itemContent: {
            px: 4,
            fontSize: 'sm',
        },
    },
});
